module.exports = __webpack_public_path__ + "img/ar05.caf2f284.jpg";